import { connect } from "knockout-store";

function modalViewModel(params) {
  const vm = {};
  vm.close = () => {
    params.modal("");
  };
  return vm;
}

function mapStateToParams({ modal }) {
  return {
    modal,
  };
}

export default connect(mapStateToParams)(modalViewModel);
